import { createSlice } from '@reduxjs/toolkit'

const initialState = {
	filters: {
		gMinTimeStamp: null,
		gMaxTimeStamp: null,
		filterEV: false,
		heroArray: [],
		villainArray: [],
		heroAliases: [],
		villainAliases: [],
		lib: 'Spin & Go',
		stack: [4.5, 32.5],
		line: '',
		status: null,
		jobId: null,
		error_street: null,
		spot: [101],
		heroPos: [],
		villainPos: [],
		ev: 0.01,
		buyIn: [0, 1000],
		heroHands: [],
		handsCount: 0,
		villainHands: [],
		villainHandsCount: 0,
		room: [],
		source: 'upload',
		player_subs: null,
		is_error: null,
		session_id: null,
		configuration_id: null,
		game_mode: null,
		is_hero: true,
		hero: null,

		heroAliasesNames: [],
		villainAliasesNames: [],
		spotForReport: [105],

		is_names: true,
		is_alias: true,
		is_hero_only: true,
	},

	// required for GPT Modal
	isLoadingHandData: false,
	isLoadingGPTResponse: false,
	isOpenGPTModal: false,
	handDataGPT: null,
	gptAnalysisData: null,

}

const handsSlice = createSlice({
	name: 'handsSlice',
	initialState,
	reducers: {
		setFilters(state, action) {
			state.filters = action.payload
		},

		// loading hand data (players, trace) for futher GPT analysis
		setIsLoadingGPTModal(state, action) {
			state.isLoadingHandData = action.payload
		},

		// set hand data (players, trace)
		setHandData(state, action){
			state.handDataGPT = action.payload
			state.isLoadingHandData = false
		},

		setIsLoadingGPTResponse(state, action) {
			state.isLoadingGPTResponse = action.payload
		},

		setGptAnalysisData(state, action) {
			state.gptAnalysisData = action.payload
		},

		setIsOpenAIAnalyzeModal(state, action) {
			state.isOpenGPTModal = action.payload
		},
	},
})
export const { reducer, actions } = handsSlice
